<template>
  <div id="app">
    <app-nav-bar></app-nav-bar>
    <app-webtoon></app-webtoon>
    <app-comicbook></app-comicbook>
    <app-events></app-events>
    <app-game></app-game>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Webtoon from './components/Webtoon.vue'
import Comicbook from './components/Comicbook.vue'
import Events from './components/Events.vue'
import Game from './components/Game.vue'
import Footer from './components/Footer.vue'
import NavBar from './components/NavBar.vue'



export default {
  name: 'App',
  components: {
    appWebtoon: Webtoon,
    appComicbook: Comicbook,
    appEvents: Events,
    appGame: Game,
    appFooter: Footer,
    appNavBar: NavBar,
    
  }
}
</script>

<style lang="scss">
  @import './styles/custom_bootstrap.scss';
  @import '../node_modules/bootstrap/scss/bootstrap.scss';
</style>

<style>

nav .inner{width:100%;}
.navbar-dark .navbar-nav .nav-link {color:rgba(255, 255, 255, 1);  font-weight: 500;}

@media screen and (min-width: 1240px){
  nav .inner{width: 1200px;margin: 0 auto;}
 #navbarBrand {display:inline-block; width: 440px;text-align: center;}  
  .nav-link {font-weight:800; font-size:20px; color:#fff; line-height: 47px;}
}

body {margin-top: 60px;}
* {
      font-family: 'Noto Sans KR', 'malgun gothic', serif !important;
}

.navbar { background:#0ec2d7}
.navbar a.navbar-brand {vertical-align:47px; display:inline-block; vertical-align: 41px; width: 165px;height: 37px;background-size: 165px auto;background:url(https://bufftoon.plaync.com/_nuxt/img/horizon-color3.svg) no-repeat;font-size:0; } 
.nav-item.active {
    position: relative;
    background: #1e91ab;
}
.navbar-dark .navbar-toggler {float:right;}
#game ,#webtoon ,#comicbook ,#events ,#footer{ padding-top:100px; }

.container .title { font-size: .75em; }
@media screen and (min-width: 300px){
.navbar-nav{
    display: table;
    width: 100%;
    margin: 0 auto;
    }
.nav-item {
    display: table-cell;
    width: 25%;
    vertical-align: top;
    text-align: center;
}
}
.height-100 {
  min-height: 100vh;
}
.height-80 {
  min-height: 80vh;
}
.height-60 {
  min-height: 60vh;
}
.height-50 {
  min-height: 50vh;
}
.height-40 {
  min-height: 40vh;
}


</style>



// WEBPACK FOOTER //
// src/App.vue